import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { ButtonCoreDriver } from '../Button/ButtonCore/ButtonCore.uni.driver';

export interface CloseButtonUniDriver extends BaseUniDriver {
  isButtonDisabled: ButtonCoreDriver['isButtonDisabled'];
}
